import Fetch, { V2, V4 } from 'Util/fetcher';

const ON_REQUEST_MF_DETAIL = 'ON_REQUEST_MF_DETAIL';
const ON_REQUEST_MF_DETAIL_FAILURE = 'ON_REQUEST_MF_DETAIL_FAILURE';
const ON_REQUEST_MF_DETAIL_SUCCESS = 'ON_REQUEST_MF_DETAIL_SUCCESS';
function onRequestMfDetail() {
  return {
    type: ON_REQUEST_MF_DETAIL,
  };
}
function onRequestMfDetailSuccess(payload) {
  return {
    type: ON_REQUEST_MF_DETAIL_SUCCESS,
    payload,
  };
}
function onRequestMfDetailFailure(payload) {
  return {
    type: ON_REQUEST_MF_DETAIL_FAILURE,
    payload,
  };
}
export const onDoRequestMfDetail = id => (dispatch) => {
  dispatch(onRequestMfDetail());
  Fetch.get(`${V2}funds/fund-bundle/${id}/`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestMfDetailSuccess(resp.json));
    } else {
      dispatch(onRequestMfDetailFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestMfDetailFailure(error.message));
  });
};


const ON_REQUEST_MF_CHART = 'ON_REQUEST_MF_CHART';
const ON_REQUEST_MF_CHART_FAILURE = 'ON_REQUEST_MF_CHART_FAILURE';
const ON_REQUEST_MF_CHART_SUCCESS = 'ON_REQUEST_MF_CHART_SUCCESS';
function onRequestMfChart() {
  return {
    type: ON_REQUEST_MF_CHART,
  };
}
function onRequestMfChartSuccess(payload) {
  return {
    type: ON_REQUEST_MF_CHART_SUCCESS,
    payload,
  };
}
function onRequestMfChartFailure(payload) {
  return {
    type: ON_REQUEST_MF_CHART_FAILURE,
    payload,
  };
}
export const onDoRequestMfChart = id => (dispatch) => {
  dispatch(onRequestMfChart());
  Fetch.get(`${V4}funds/${id}/chart/`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestMfChartSuccess(resp.json));
    } else {
      dispatch(onRequestMfChartFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestMfChartFailure(error.message));
  });
};


const ON_REQUEST_MF_SIMULATOR = 'ON_REQUEST_MF_SIMULATOR';
const ON_REQUEST_MF_SIMULATOR_FAILURE = 'ON_REQUEST_MF_SIMULATOR_FAILURE';
const ON_REQUEST_MF_SIMULATOR_SUCCESS = 'ON_REQUEST_MF_SIMULATOR_SUCCESS';
function onRequestMfSimulator() {
  return {
    type: ON_REQUEST_MF_SIMULATOR,
  };
}
function onRequestMfSimulatorSuccess(payload) {
  return {
    type: ON_REQUEST_MF_SIMULATOR_SUCCESS,
    payload,
  };
}
function onRequestMfSimulatorFailure(payload) {
  return {
    type: ON_REQUEST_MF_SIMULATOR_FAILURE,
    payload,
  };
}
export const onDoRequestMfSimulator = id => (dispatch) => {
  dispatch(onRequestMfSimulator());
  Fetch.get(`${V2}funds/${id}/simulator/`).then((resp) => { 
    if (resp.ok) { 
      dispatch(onRequestMfSimulatorSuccess(resp.json));
    } else {
      dispatch(onRequestMfSimulatorFailure(resp.json));
    }
  }).catch((error) => {
    dispatch(onRequestMfSimulatorFailure(error.message));
  });
};


const INITIAL_STATE = {
  detailLoading: false,
  detailData: null,
  detailError: null,

  chartLoading: false,
  chartData: null,
  chartError: null,

  simulatorLoading: false,
  simulatorData: null,
  simulatorError: null,
};

const mfDetailComponent = (state = INITIAL_STATE, { type, payload } = {}) => {
  switch (type) {
    case ON_REQUEST_MF_DETAIL:
      return {
        ...state,
        detailLoading: true,
        detailError: null
      };
    case ON_REQUEST_MF_DETAIL_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        detailData: payload,
        detailError: null
      };
    case ON_REQUEST_MF_DETAIL_FAILURE:
      return {
        ...state,
        detailLoading: false,
        detailError: payload
      };

    case ON_REQUEST_MF_CHART:
      return {
        ...state,
        chartLoading: true,
        chartError: null
      };
    case ON_REQUEST_MF_CHART_SUCCESS:
      return {
        ...state,
        chartLoading: false,
        chartData: payload,
        chartError: null
      };
    case ON_REQUEST_MF_CHART_FAILURE:
      return {
        ...state,
        chartLoading: false,
        chartError: payload
      };

    case ON_REQUEST_MF_SIMULATOR:
      return {
        ...state,
        simulatorLoading: true,
        simulatorError: null
      };
    case ON_REQUEST_MF_SIMULATOR_SUCCESS:
      return {
        ...state,
        simulatorLoading: false,
        simulatorData: payload,
        simulatorError: null
      };
    case ON_REQUEST_MF_SIMULATOR_FAILURE:
      return {
        ...state,
        simulatorLoading: false,
        simulatorError: payload
      };

    default:
      return state;
  }
};

export default mfDetailComponent;
